export default "__VITE_ASSET__B64i98Zv__"